<ngx-spinner  bdColor="rgba(128, 128, 128, 0.8)"
              size="default"
              color="#2f9cf2"
              type="line-scale-pulse-out"
              [name]="spinnerName"
              [fullScreen]="false"><p style="color:white">{{spinnerText}}</p></ngx-spinner>

<p-toast position="top-right"></p-toast>

<div class="role-operation-management-page">
  <p-toolbar>
    <div class="p-toolbar-group-left">
      <p-breadcrumb [model]="items"></p-breadcrumb>
    </div>
  </p-toolbar>

  <p-splitter class="role-operation-splitter" styleClass="role-operation-splitter-root" [layout]="smallScreen ? 'vertical' : 'horizontal'" [panelSizes]="[40,60]" [gutterSize]="8">
    <ng-template pTemplate>
      <div class="role-operation-panel">
        <div class="section-title">Roles</div>
        <ag-grid-angular
            style="width: 100%;"
            class="ag-theme-alpine role-operation-grid"
            [rowData]="roles"
            [columnDefs]="roleGridHeaders"
            [context]="context"
            [rowSelection]="{ mode: 'singleRow', checkboxes: false, enableClickSelection: true }"
            (gridReady)="onRoleGridReady($event)"
            (selectionChanged)="onRoleSelectionChanged($event)"></ag-grid-angular>
      </div>
    </ng-template>

    <ng-template pTemplate>
      <div class="role-operation-panel">
        <div class="section-title">Permission Settings</div>
        <ag-grid-angular
            style="width: 100%;"
            class="ag-theme-alpine role-operation-grid"
            [rowData]="roleOperations"
            [columnDefs]="roleOperationGridHeaders"
            [context]="context"
            [rowSelection]="{ mode: 'singleRow', checkboxes: false, enableClickSelection: true }"
            (gridReady)="onRoleOperationGridReady($event)"></ag-grid-angular>
      </div>

    </ng-template>
  </p-splitter>
</div>